import React, { useEffect, useState, useRef } from 'react'
import { Card, CardHeader, CardBody, Label } from "reactstrap";
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from "react-redux";
import TextEditor from '../../../../../../../Components/TextEditor';
import DynamicText from './DynamicText';
import DynamicImage from './DynamicImage';
import DynamicVideo from './DynamicVideo';
import { openCampaign, saveDynamicText, setCreativesDynamicText, setFontCssBeforeSave, updateVersionStatusAfterUpdate } from '../../../../../../../slices/campaigns/thunk';
import { setPreloader } from '../../../../../../../slices/layouts/reducer';
import { setCampaignLoader, setDynamicVideoError, setIsApplyAll, setIsCreativeLevelFilter } from '../../../../../../../slices/campaigns/reducer';
import { sortAlphabetically } from '../../../../../../../slices/helper';
import CustomSelect from '../../../../../../../Components/Common/CustomSelect';
import SimpleBar from 'simplebar-react';
import { setBreadcrumb } from '../../../../../../../slices/auth/menu/reducer';
// import { setDisableSetPreview, setDynamicText, setSelectedCreativeDynamicText } from '../../../../../../../slices/campaigns/reducer';
// import { getVersionDynamicTextValues, saveDynamicText, setCreativesDynamicText } from '../../../../../../../slices/campaigns/thunk';

function DynamicEditArea() {
  const dispatch = useDispatch();
  const scrollableNodeRef = useRef();
  const selectDynamicText = createSelector(state => state.Campaign, state => ({
    dynamicText: state.dynamicText,
    activeDynamicText: state.activeDynamicText,
    selectedCreative: state.selectedCreative,
    isApplyAll: state.isApplyAll,
    creativeLevelFilter: state.creativeLevelFilter,
    currentCampaign: state.currentCampaign,
    currentVersion: state.currentVersion,
    creatives: state.creatives,
    scrolledCreatives: state.scrolledCreatives,
    dynamicVideoError: state.dynamicVideoError
  }));
  const { dynamicText, activeDynamicText, selectedCreative, isApplyAll, creativeLevelFilter, currentCampaign, currentVersion, creatives, scrolledCreatives, dynamicVideoError } = useSelector(selectDynamicText);
  const [groupedDynamicTexts, setGroupedDynamicTexts] = useState(null);
  const [dynamicItems, setDynamicItems] = useState([]);

  useEffect(() => {
    dispatch(setCreativesDynamicText());
  }, [dynamicText]);

  useEffect(() => {
    checkDynamicTextVideo();
  }, [activeDynamicText, dynamicText]);

  useEffect(() => {
    setTimeout(() => {
      if (scrollableNodeRef.current) {
        scrollableNodeRef.current.scrollTop = 0
      }
    }, 2);
  }, [selectedCreative]);

  useEffect(() => {
    if (activeDynamicText) {
      if (activeDynamicText.isCreative === true) {
        // setGroupedDynamicTexts(null);
        // setTimeout(() => {
        setGroupedDynamicTexts(activeDynamicText)
        // }, 1);
      } else if (activeDynamicText.isCreative === false) {
        let groupedDynamicTextsVar = { ...dynamicText[0] };
        if (!selectedCreative) {
          groupedDynamicTextsVar.texts = [];
          let i = 0;
          do {
            const texts = dynamicText[i].texts;
            let k = 0;
            do {
              groupedDynamicTextsVar.texts.push({ ...texts[k], dynamicTextIdx: i });
              k++;
            } while (k < texts.length);
            i++;
          } while (i < dynamicText.length);
          groupedDynamicTextsVar.texts = Object.values(
            groupedDynamicTextsVar.texts.reduce((acc, item) => {
              if (!acc[item.tag]) {
                acc[item.tag] = [{ ...item, dynamicTextIdxs: [item.dynamicTextIdx], value: item.value, dynamicTextSizes: [] }];
              } else {
                const foundItemTag = acc[item.tag].find(searchItem => searchItem.tag === item.tag && searchItem.value === item.value);
                const foundCreative = creatives?.find(creative => creative._id === dynamicText[item.dynamicTextIdx].creativeId);
                if (foundItemTag) {
                  foundItemTag.dynamicTextIdxs.push(item.dynamicTextIdx);
                  if (foundCreative) {
                    foundItemTag.dynamicTextSizes.push(foundCreative.size);
                  }
                } else {
                  acc[item.tag].push({ ...item, dynamicTextIdxs: [item.dynamicTextIdx], value: item.value, dynamicTextSizes: [foundCreative?.size] })
                }
              }
              return acc;
            }, {})
          )
        }
        // setGroupedDynamicTexts(null);
        // setTimeout(() => {
        setGroupedDynamicTexts(groupedDynamicTextsVar);
        // }, 1);
      }
    } else {
      setGroupedDynamicTexts(null);
      setDynamicItems([]);
    }
  }, [activeDynamicText]);

  useEffect(() => {
    if (groupedDynamicTexts) {
      handleDynamicItems();
    }
  }, [groupedDynamicTexts]);

  async function saveChanges() {
    dispatch(setCampaignLoader(true));
    const dynamicVideoErrorMsg = await dispatch(saveDynamicText(false));
    const updatedChanges = await dispatch(updateVersionStatusAfterUpdate());
    dispatch(setCampaignLoader(false));
    dispatch(setBreadcrumb({ pageTitle: 'Ad Library', title: [] }));
    await dispatch(openCampaign(currentCampaign, updatedChanges.updatedVersion));
    if (dynamicVideoErrorMsg) {
      dispatch(setDynamicVideoError({
        dynamicVideoError: true,
        dynamicVideoErrorMsg: dynamicVideoErrorMsg
      }));
    }
  }

  function handleDynamicItems() {
    let dynamicItemsArr = [];
    let i = 0;
    do {
      const text = groupedDynamicTexts.texts[i];
      if (Array.isArray(text)) {
        let k = 0;
        do {
          dynamicItemsArr.push(text[k]);
          k++;
        } while (k < text.length);
      } else {
        dynamicItemsArr.push(text);
      }
      i++;
    } while (i < groupedDynamicTexts.texts.length);
    dynamicItemsArr = dynamicItemsArr.filter(dItem => dItem !== null);
    setDynamicItems(dynamicItemsArr);
  }

  function filterDynamicText(item, idx) {
    if (item.type === 'text' && activeDynamicText) {
      if (activeDynamicText.isCreative === true || selectedCreative ? (creativeLevelFilter === 'text' || creativeLevelFilter === 'all' ? true : false) : true) {
        return (
          <DynamicText key={idx} item={item} idx={idx} />
        )
      }
    } else if (item.type === 'image' && activeDynamicText) {
      if (activeDynamicText.isCreative === true || selectedCreative ? (creativeLevelFilter === 'image' || creativeLevelFilter === 'all' ? true : false) : false) {
        return (
          <DynamicImage key={idx} item={item} idx={idx} scrollableNodeRef={scrollableNodeRef} />
        )
      }
    } else if (item.type === 'video' && activeDynamicText) {
      if (activeDynamicText.isCreative === true || selectedCreative ? (creativeLevelFilter === 'image' || creativeLevelFilter === 'all' ? true : false) : false) {
        return (
          <DynamicVideo key={idx} item={item} value={item.value} poster={item.poster} idx={idx} scrollableNodeRef={scrollableNodeRef} />
        )
      }
    } else {
      return null;
    }
  }

  function handleFilterChange(value) {
    dispatch(setIsCreativeLevelFilter(value));
  }

  function checkDynamicTextVideo() {
    dispatch(setDynamicVideoError({
      dynamicVideoError: false,
      dynamicVideoErrorMsg: ``
    }));
    let i = 0;
    do {
      let dynamicTextName = 'Global Translation';
      if (dynamicText[i].isCreative) {
        const foundCreative = scrolledCreatives.find(creative => creative._id === dynamicText[i].creativeId);
        if (foundCreative) {
          dynamicTextName = foundCreative.size;
        }
      }
      const filteredTexts = dynamicText[i].texts.filter(text => text.type === 'video');
      if (filteredTexts.length > 0) {
        let k = 0;
        do {
          const videoText = filteredTexts[k];
          if ((videoText.value && videoText.value.trim() !== '' && videoText.poster && videoText.poster.trim() !== '')
            || (videoText.hasOwnProperty('file') && videoText.hasOwnProperty('posterFile'))) {

          } else {
            let missingPart = '';
            if (!videoText.value) {
              missingPart = 'video';
            } else if (!videoText.poster) {
              missingPart = 'poster';
            }
            dispatch(setDynamicVideoError({
              dynamicVideoError: true,
              dynamicVideoErrorMsg: `${dynamicTextName} - ${videoText.name} ${missingPart} missing.`
            }));
            break;
          }
          k++;
        } while (k < filteredTexts.length);
      }
      i++;
    } while (i < dynamicText.length);
  }

  return (
    <Card className='dynamic-text-edit-area'>
      <CardHeader className='d-flex align-items-center justify-content-between'>
        <p className='p-0 m-0'>{selectedCreative === null ? 'Global Translations' : selectedCreative.size}</p>
        {selectedCreative ?
          <div className='d-flex align-items-center justify-content-between'>
            <CustomSelect
              options={[{ name: 'Text', value: 'text' }, { name: 'Image', value: 'image' }, { name: 'All', value: 'all' }]}
              placeholder='Set Filter'
              className='dropdown-toggle btn btn-sm btn-light'
              onChange={(item) => handleFilterChange(item.value)}
              value={creativeLevelFilter.slice(0, 1).toUpperCase() + creativeLevelFilter.slice(1, creativeLevelFilter.length)}
            />
          </div>
          : null}
      </CardHeader>
      <CardBody className='d-flex flex-column p-0'>
        <SimpleBar style={{
          maxHeight: 'calc(100% - 70px)',
          minHeight: (dynamicItems && dynamicItems.length < 5 ? `${dynamicItems.length * 200}px` : 'auto'),
          overflowX: 'hidden'
        }} className='px-3 pt-2 gap-4' scrollableNodeProps={{ ref: scrollableNodeRef }}>
          {dynamicItems && dynamicItems.length > 0 && dynamicItems.map((item, idx) => {
            return filterDynamicText(item, idx);
          })}
        </SimpleBar>
        <div className='w-100 d-flex align-items-center justify-content-end mt-3'>
          {/* {selectedCreative === null ?
            <button className='btn btn-dark me-1' onClick={() => {
              dispatch(setIsApplyAll(true))
              saveChanges();
            }}>Apply Changes To All</button>
            : null} */}
          <button className='btn btn-success me-2' onClick={saveChanges} disabled={dynamicVideoError}>Save Changes</button>
        </div>
      </CardBody>
    </Card>
  )
}

export default DynamicEditArea
